import type { Meta, Patient } from 'fhir/r4';
import { gql } from 'graphql-request';
import type { GraphqlConnectionNode, GraphqlPageInfo } from '../client';
import { fragmentOrganization, fragmentPatient, fragmentPatientListItem } from './fragments';

export interface PatientConnection {
  pageInfo: GraphqlPageInfo;
  edges: Array<GraphqlConnectionNode<Patient>>;
}

export interface PatientGraphqlResponse {
  PatientConnection: PatientConnection;
}

type PatientListItemMeta = Pick<Meta, 'versionId' | 'lastUpdated' | 'extension'>;

export interface PatientListItem
  extends Pick<
    Patient,
    'id' | 'resourceType' | 'extension' | 'identifier' | 'name' | 'birthDate' | 'gender' | 'telecom'
  > {
  meta?: PatientListItemMeta;
}

export interface PatientListItemConnection {
  pageInfo: GraphqlPageInfo;
  edges: Array<GraphqlConnectionNode<PatientListItem>>;
}

export interface PatientListItemGraphqlResponse {
  PatientConnection: PatientListItemConnection;
}

export const patientsForUPIDQuery = gql`
  ${fragmentPatient}
  ${fragmentOrganization}

  query PatientsForUpid(
    $upid: ID!
    $cursor: String!
    $sort: PatientSortParams!
    $first: Int!
    $filter: PatientFilterParams! = {}
  ) {
    PatientConnection(upid: $upid, after: $cursor, sort: $sort, first: $first, filter: $filter) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          ...Patient
        }
      }
    }
  }
`;

export const patientsForBuilderQuery = gql`
  ${fragmentPatientListItem}

  query PatientsForBuilder(
    $builderID: ID!
    $cursor: String!
    $first: Int!
    $filter: PatientFilterParams! = {}
  ) {
    PatientConnection(builderID: $builderID, after: $cursor, first: $first, filter: $filter) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...PatientListItem
        }
      }
    }
  }
`;
